import i18n from "i18next";
import * as Yup from "yup";

import type { CountryCode } from "@krea/shared/types/common";
import { minFinancingAmountPerCountry } from "@krea/shared/utils/formConstants";

export const RequestedLoanAmountValidation = (countryCode: CountryCode) => {
  return Yup.number()
    .moreThan(
      minFinancingAmountPerCountry[countryCode].numericValue - 1,
      i18n.t("formFields.minimumAmountError", {
        ns: "formFields",
        amount: minFinancingAmountPerCountry[countryCode].stringValue,
      }),
    )
    .typeError(
      i18n.t("formFields.requestedAmountErrors.typeError", {
        ns: "formFields",
      }),
    )
    .required(
      i18n.t("formFields.requestedAmountErrors.required", {
        ns: "formFields",
      }),
    );
};
